<template>
  <div class="dolu_vic">
      <div class="row">
          <div class="col-1">
          </div>

          <div class="col-10 bg-transparent">
              <card class="bg-transparent" plain>
                  <h1 class="text-center bold-text">
                    EXAMINATION SHEET DESCRIPTION
                  </h1>
                  <h3 class="text-center bold-text">
                    Based on the GiSAID form
                  </h3>
              </card>
          </div>

          <div class="col-1">
          </div>
      </div>


      <div class="row dolu_min">
          <div class="col-10 mr-auto ml-auto">
              <card class="vyska text-center" plain>
                <p><b>sample_id:</b><br /> <b>This field is mandatory!!!</b> Value is prefix of FASTQ file. For example if file name is SAMPLE_S1_L001_R1_001.fastq.gz, prefix is <b>SAMPLE</b>. </p>
                <p><b>collection_date:</b><br /> Date is in format YYYY-MM-DD.</p>
                <p><b>add_host_info:</b><br /> e.g. Patient infected while traveling in …. </p>
                <p><b>gender:</b><br /> Male or Female.</p>
                <p><b>patient_age:</b><br /> e.g.  65 or 7 months.</p>
                <p><b>patient_status:</b><br /> e.g.  Hospitalized, Released, Live, Deceased, or unknown.</p>
                <p><b>speciment_source:</b><br /> e.g. Sputum, Alveolar lavage fluid, Oro-pharyngeal swab, Blood, Tracheal swab, Urine, Stool, Cloakal swab, Organ, Feces, Other.</p>
                <p><b>outbreak:</b><br /> Date, Location e.g. type of gathering, Family cluster, etc..</p>
                <p><b>last_vaccinated:</b><br /> Provide details if applicable.</p>
                <p><b>treatment:</b><br /> Include drug name, dosage.</p>
                <p><b>comment:</b><br /> Any additional comments.</p>
                <p><b>zip_code:</b><br /> ZIP code of the city.</p>
                <p></p>


              </card>
          </div>
      </div>



      <div class="row dolu_min">
          <div class="col-6 mr-auto ml-auto">
              <card plain>
                <div class="row">
                  <div class="col-12 mr-auto ml-auto">
                    <h4 class="hesla text-center">Download Examinations Sheet:</h4>
                  </div>

                  <div class="col-4 mr-auto ml-auto text-center">
                    <a class="" aria-label="logo" href="/static/examination_sheet_covid_TEMPLATE_with_data_example.xlsx" target="_blank"> HERE!
                    </a>
                  </div>

                </div>
              </card>
          </div>
      </div>



  </div>
</template>
<script>
  import { Card  } from 'element-ui'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard';

  import Loading from 'src/components/Layout/LoadingMainPanel.vue'
  import TaskList from './Widgets/TaskList'

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

  const tooltipOptions = {
    tooltipFillColor: "rgba(0,0,0,0.5)",
    tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipFontSize: 14,
    tooltipFontStyle: "normal",
    tooltipFontColor: "#fff",
    tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipTitleFontSize: 14,
    tooltipTitleFontStyle: "bold",
    tooltipTitleFontColor: "#fff",
    tooltipYPadding: 6,
    tooltipXPadding: 6,
    tooltipCaretSize: 8,
    tooltipCornerRadius: 6,
    tooltipXOffset: 10,
  };

  export default {
    components: {
      Card,
      TaskList,
      StatsCard,

    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      return {


      }
    },





  }

</script>
<style scoped>
  .main-panel {
    padding-top: 90px !important;
    padding-left: 220px !important;
    padding-right: 220px !important;
  }

  .main-panel > .content {
      min-height: calc(100vh - 10px) !important;
  }

.el-card {
  border: 0px !important;
}

.bg-transparent {
  background-color: transparent !important;

}


.bold-text {
  font-weight: 900;
}


.logo-img {
  height: 100px !important;
}

.vyska {
  min-height: 400px !important;
}

.dolu_vic {
  padding-top: 80px !important;
  padding-right: 220px !important;
}

.dolu_min {
  padding-top: 25px !important;
}

</style>
